/* Hands the bundle filter view to the builder.

   sf-bundlefilters.js defines window.__bundleView. sf-claude.js looks for
   window.SF.bundleView when it renders. This connects the two, and is
   loaded between them so the order is explicit rather than accidental. */
(function(){
"use strict";
document.addEventListener('DOMContentLoaded', function(){
  if(!document.getElementById('bGrid')) return;
  if(window.SF && typeof window.__bundleView==='function'){
    window.SF.bundleView=window.__bundleView;
    if(typeof window.SF.renderBundles==='function') window.SF.renderBundles();
  }
});
})();